import React, { useEffect, useState } from "react";
import { useSocket } from "../../../hooks/useSocket";
import { loadStyles } from "../../../utils/cssLoader";
import NoDataFound from "../../common/NoDataFound";
import CricketLeagueBox from "./CricketLeagueBox";
import { useCricketSocket } from "../../../hooks/useCricketSocket";


const CricketLeagueMatches = ({
  finalData,
  difference,
  matchType,
  loadCSS,
  dataClient,
  websiteBaseUrl,
  dataPath = "cricket",
  type = "cricket",
  sport = "cricket",
  displayDate = false,
  dictionary = {},
  socketUrl = "",
  baseUrl,
  allowedLeagues, tournamentListing
}) => {

  const [data, setData] = useState(finalData);
  useEffect(() => {
    setData(finalData)

  }, [finalData]);

  const baseURL =
    process.env.REACT_APP_BASE_URL ??
    "https://ipublisher-microservices.6lgx.com";

  const socket = useSocket(socketUrl);
  useCricketSocket(socket, sport, setData, allowedLeagues);
  useEffect(() => {
    if (loadCSS === "true") loadStyles("leaguepage");
  }, [loadCSS]);

  if (!data?.length) {
    return (
      <div className="leg_wrp">
        <div className="leg_box">
          <div className="text-center">
            <NoDataFound />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="leg_wrp">
      {matchType === "upcoming" && !data[0]?.nm && (
        <div className="leg_head">
          <h2>
            <span className="name">Upcoming Matches</span>
          </h2>
        </div>
      )}

      <CricketLeagueBox
        data={data}
        difference={difference}
        displayDate={displayDate}
        dictionary={dictionary}
        baseURL={baseURL}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        dataClient={dataClient}
        sport={sport}
        tournamentListing={tournamentListing}
      />
    </div>
  );
};

export default CricketLeagueMatches;
